import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {Form, Input, Button, Checkbox, InputNumber} from "antd";
import {Row, Col, Alert, Select, Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import AuthBg from "../../components/background/AuthBg";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {authActions, dataActions} from "_actions";
import {Steps} from "antd";

import "../../assets/sass/auth.scss";
import {history} from "../../_helpers";
import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import luxfi from "../../assets/img/lux-register-no-bg.png";
import ReCAPTCHA from "react-google-recaptcha";
import {PasswordInput} from "antd-password-input-strength";
import {xcService} from "../../_services/xcService";
import {useRef} from "react";
import {infoCenter, noCaptcha} from "_config";

import {isMobile, isTablet} from "react-device-detect";
import variables from "_constants/variables";
const {Step} = Steps;

const {Option} = Select;

function RegisterPage(props) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {t, i18n} = useTranslation();

  const captchaRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [nameCenter, setNameCenter] = useState(null);
  const [acceptlegal, setAcceptLegal] = useState(false);
  const [values, setValues] = useState(null);
  const [valsOne, setValsOne] = useState(null);
  const [errorCenter, setErrorCenter] = useState(false);
  const [vinculado, setVinculado] = useState(true);
  const [auto, setAuto] = useState(false);
  const [current, setCurrent] = useState(0);
  const [courses, setCourses] = useState([]);

  const [codeError, setCodeError] = useState(null);
  const [valueCountry, setValueCountry] = useState(null);

  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const minLevel = 0;
  const [level, setLevel] = useState(0);
  const errorMessage = t("cuenta.debil");
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  var registerUser = useSelector((state) => state.authReducer.registerUser);
  var registerUserError = useSelector((state) => state.authReducer.registerUserError);

  var checkCodeCenter = useSelector((state) => state.authReducer.checkCodeCenter);
  var checkCodeCenterError = useSelector((state) => state.authReducer.checkCodeCenterError);
  var coursesData = useSelector((state) => state.dataReducer.coursesData);

  var countriesData = useSelector((state) => state.dataReducer.countriesData);

  var provincesData = useSelector((state) => state.dataReducer.provincesData);

  function onChangeCountry(value) {
    setProvinces(null);
    setValueCountry(value);
    dispatch(dataActions.getProvincesCountry(value));
  }

  useEffect(() => {
    if (coursesData) setCourses(coursesData);
  }, [coursesData]);

  useEffect(() => {
    if (countriesData) setCountries(countriesData);
  }, [countriesData]);

  useEffect(() => {
    if (provincesData) setProvinces(provincesData);
  }, [provincesData]);
  useEffect(() => {
    if (!coursesData) getCourses();

    //  if (!provincesData) getProvinces();
    if (!countriesData) getCountries();
  }, []);

  const getCourses = () => {
    dispatch(dataActions.getCourses());
  };

  const getCountries = () => {
    dispatch(dataActions.getCountries());
  };
  const getProvinces = () => {
    dispatch(dataActions.getProvinces());
  };

  const getProvincesCountry = () => {
    dispatch(dataActions.getProvincesCountry());
  };

  useEffect(() => {
    setLoading(false);

    if (registerUser) {
      setAuto(registerUser?.data?.auto);
      setError(false);
      setErrorMsg("");
      setCurrent(6);
    }
    if (registerUserError) {
      setError(true);
      setErrorMsg(t(registerUserError.code));
    }
  }, [registerUser, registerUserError]);

  const onFinishStep1 = (vals) => {
    setValsOne(vals);
    setErrorCenter(null);
    // setValues({...values, ...vals});
    dispatch(authActions.checkCode({centerCode: vals.centerCode, passwordCenter: vals.passwordCenter}));
    setLoading(true);
    // setCurrent(2)
  };

  useEffect(() => {
    if (checkCodeCenter) {
      setValues({...values, ...valsOne});
      setCurrent(2);
      setLoading(false);
    }
    if (checkCodeCenterError) {
      setCodeError(checkCodeCenterError?.code);
      setLoading(false);
      setErrorCenter(true);
    }
  }, [checkCodeCenter, checkCodeCenterError]);

  const onFinishStep2 = (vals) => {
    setValues({...values, ...vals});

    setCurrent(3);
  };

  const onFinishStep3 = (vals) => {
    setValues({...values, ...vals});
    setCurrent(4);
  };

  const onFinishStep4 = (vals) => {
    if (noCaptcha) return acceptForm(vals);

    setErrorMsg("");

    const token = captchaRef.current.getValue();
    setError(false);
    setErrorMsg("");
    xcService
      .post("/v1/captcha", {token})
      .then((res) => {
        captchaRef.current.reset();
        if (res.data.success) {
          acceptForm(vals);
        } else {
          setError(true);
          setErrorMsg("captcha");
        }
      })
      .catch((error) => {
        captchaRef.current.reset();
      });
  };

  const acceptForm = (vals) => {
    const mBody = {...values, ...vals};
    if (!vinculado) {
      mBody.centerCode = infoCenter.code;
      mBody.passwordCenter = infoCenter.passCode;
    }
    mBody.access = isMobile ? "MOBILE" : isTablet ? "TABLET" : "DESKTOP";
    setValues({...values, ...vals});
    setLoading(true);
    setError(false);
    dispatch(authActions.register(mBody));
  };

  const onChange = (value) => {
    if (!vinculado) {
      if (value > 0 && value < 3) setCurrent(0);
    } else {
      setCurrent(value);
    }
    let scrollContainers = document.querySelectorAll(".is-scrollable");
    scrollContainers.forEach((cont) => (cont.scrollTop = 0));
  };

  useEffect(() => {
    if (current !== 0 && current !== 6) {
      if (values) {
        const {setFieldsValue, getFieldValue} = form;

        setFieldsValue(values);
      }
    }
  }, [current]);

  const goTo = (vinculado, step) => {
    setVinculado(vinculado);
    setCurrent(step);
    let scrollContainers = document.querySelectorAll(".is-scrollable");
    scrollContainers.forEach((cont) => (cont.scrollTop = 0));
  };

  const back = () => {
    if (vinculado) {
      setCurrent(current - 1);
    } else {
      setCurrent(1);
    }
  };

  const changeCenterCode = (e) => {
    if (e.target.value.length > 4) {
      setNameCenter(null);
      setErrorCenter(false);
      xcService.get("/v1/check/center/" + e.target.value).then(({data}) => {
        setNameCenter(data.data);
        if (data.code === "3000") {
          // El cenro no existe

          setErrorCenter(true);
        }
      });
    } else {
      setErrorCenter(false);
      setNameCenter(null);
    }
  };

  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <>
      <div className="containerRowRegister">
        <NavbarNoLogin className="menuNavRegister" />

        <div className="colRegister leftRegister">
          <h1>{t("welcome")}</h1>

          <AuthBg />
        </div>
        <div className="colRegister rightRegister">
          <div className="headerMobile">
            <h1>{t("welcome")}</h1>
          </div>

          <div className="containerRegister">
            <div className="centerRegister">
              {current !== 6 && <h2>{t("registro.registro")}</h2>}
              {current !== 6 && current !== 0 && (
                <Steps
                  direction={"horizontal"}
                  responsive={false}
                  type="navigation"
                  size="small"
                  current={current}
                  onChange={onChange}
                  className="site-navigation-steps"
                >
                  <Step />
                  <Step disabled={current + 1 < 2} />
                  <Step disabled={current + 1 < 3} />
                  <Step disabled={current + 1 < 4} />
                  <Step disabled={current + 1 < 5} />
                </Steps>
              )}
              {current === 0 && (
                <div className={"first-content is-scrollable is-scrollable--student"}>
                  <div className="textDesc">{t("registro.pregunta")}</div>
                  <div style={{marginTop: 32}} className="centerMobile">
                    <Button onClick={() => goTo(true, 1)} className="primaryButton btnPrimaryWhite buttonSizeO">
                      {t("registro.sicentro")}
                    </Button>
                  </div>
                  <div style={{marginTop: 32}} className="centerMobile">
                    <Button onClick={() => goTo(false, 4)} className="primaryButton btnPrimaryWhite buttonSizeO">
                      {t("noinvitado")}
                    </Button>
                  </div>
                  <div
                    style={{marginTop: 24}}
                    className="textDesc"
                    dangerouslySetInnerHTML={{__html: t("registro.alumnotienescuenta")}}
                  />
                </div>
              )}
              {current === 1 && (
                <div className="allHeightMobile is-scrollable is-scrollable--student">
                  <div className="textDesc margintop24">{t("registro.datoscentro")}</div>
                  <div className="customTextSmall">{t("registro.rellenardatoscentro")}</div>
                  <div className="customTextSmall is-required">{t("obligatorio")}</div>
                  <div className="margintop24 allHeightMobile">
                    <Form
                      className="authForm allHeightMobile"
                      form={form}
                      onFinish={onFinishStep1}
                      name="basic"
                      layout="vertical"
                      labelCol={{span: 24}}
                      wrapperCol={{span: 24}}
                      initialValues={{remember: true}}
                      autoComplete="off"
                    >
                      <Form.Item
                        label={
                          <div>
                            <span>{t("registro.codigoc")}</span>&nbsp;&nbsp;
                            <Tooltip title={t("registro.tooltipcodigo")}>
                              <QuestionCircleOutlined />
                            </Tooltip>
                          </div>
                        }
                        name="centerCode"
                        rules={[
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                        ]}
                      >
                        <Input onChange={changeCenterCode} placeholder={t("registro.codigoc")} />
                      </Form.Item>
                      {nameCenter && (
                        <div className={"infoCenterData"}>
                          <h4>{t("registercenter.nombrecentro")}</h4>
                          <p>
                            {nameCenter.name}
                            <br />
                            {nameCenter.address}
                            <br />
                          </p>
                        </div>
                      )}

                      <Form.Item
                        // label={t("registro.clave")}
                        label={
                          <div>
                            <span>{t("registro.clave")}</span>&nbsp;&nbsp;
                            <Tooltip title={t("registro.tooltipclave")}>
                              <QuestionCircleOutlined />
                            </Tooltip>
                          </div>
                        }
                        name="passwordCenter"
                        rules={[
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                        ]}
                      >
                        <Input.Password placeholder={t("registro.clavep")} />
                      </Form.Item>
                      {errorCenter && (
                        <Row>
                          <Col span={24}>
                            <Alert message={codeError ? t(codeError) : t("registro.errorCenter")} type="error" />
                          </Col>
                        </Row>
                      )}
                      <Form.Item className="buttons-pre-next">
                        <Button
                          className="primaryButton btnPrimaryWhite buttonSizeS"
                          onClick={() => setCurrent(current - 1)}
                          htmlType="button"
                        >
                          {t("atras")}
                        </Button>

                        <Button
                          loading={loading}
                          className="primaryButton btnPrimaryBlue buttonSizeS"
                          type="primary"
                          htmlType="submit"
                        >
                          {t("next")}
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              )}

              {current === 2 && (
                <div className="allHeightMobile is-scrollable is-scrollable--student">
                  <div className="textDesc margintop24">{t("registro.datoscurso")}</div>
                  <div className="customTextSmall">{t("registro.rellenardatoscurso")}</div>
                  <div className="customTextSmall is-required">{t("obligatorio")}</div>
                  <div className="margintop24 allHeightMobile">
                    <Form
                      className="authForm allHeightMobile"
                      form={form}
                      onFinish={onFinishStep2}
                      name="basic"
                      layout="vertical"
                      labelCol={{span: 24}}
                      wrapperCol={{span: 24}}
                      initialValues={{remember: true}}
                      autoComplete="off"
                    >
                      <Form.Item
                        label={t("registro.curso")}
                        name="course_id"
                        rules={[
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("registro.courseplace")}
                          showSearch={true}
                          defaultActiveFirstOption={true}
                          filterOption={filterOption}
                          notFoundContent={null}
                        >
                          {courses.map((d) => {
                            return (
                              <Option value={d.id} key={d.id}>
                                {d.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        labelCol={{span: 10}}
                        wrapperCol={{span: 10}}
                        name="group"
                        style={{width: "50% !important"}}
                        label={t("registro.grupo")}
                        hasFeedback
                        rules={[
                          {required: true, message: t("mandatory")},
                          ({getFieldValue}) => ({
                            validator(_, value) {
                              var DNI_REGEX = /^([A-Z])$/;
                              value = value.toUpperCase();
                              value = value.toUpperCase().replace(/\s/, "");
                              if (value.match(DNI_REGEX)) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(new Error(t("registro.grupoperror")));
                              }
                            },
                          }),
                        ]}
                      >
                        <Input
                          onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                          placeholder={t("registro.grupoplace")}
                        />
                      </Form.Item>
                      <Form.Item
                        name="listNumber"
                        label={
                          <div>
                            <span>{t("registro.lista")}</span>&nbsp;&nbsp;
                            <Tooltip title={t("registro.tooltiplista")}>
                              <QuestionCircleOutlined />
                            </Tooltip>
                          </div>
                        }
                        hasFeedback
                        rules={[{required: true, message: t("mandatory")}]}
                      >
                        <InputNumber min={1} max={90} />
                      </Form.Item>
                      <Form.Item className="buttons-pre-next">
                        <Button
                          className="primaryButton buttonSizeS btnPrimaryWhite"
                          onClick={() => setCurrent(current - 1)}
                          htmlType="button"
                        >
                          {t("atras")}
                        </Button>

                        <Button className="primaryButton buttonSizeS btnPrimaryBlue" type="primary" htmlType="submit">
                          {t("next")}
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              )}

              {current === 3 && (
                <div className="allHeightMobile is-scrollable is-scrollable--student">
                  <div className="textDesc margintop24">{t("registro.datospersonales")}</div>
                  <div className="customTextSmall is-required">{t("obligatorio")}</div>
                  <div className="margintop24 allHeightMobile">
                    <Form
                      className="authForm allHeightMobile"
                      form={form}
                      onFinish={onFinishStep3}
                      name="basic"
                      layout="vertical"
                      labelCol={{span: 24}}
                      wrapperCol={{span: 24}}
                      initialValues={{remember: true}}
                      autoComplete="off"
                    >
                      <Form.Item label={t("registro.name")} name="name">
                        <Input placeholder={t("registro.namep")} />
                      </Form.Item>
                      <Form.Item label={t("registro.surname")} name="surname">
                        <Input placeholder={t("registro.surnamep")} />
                      </Form.Item>
                      <Form.Item
                        name="age"
                        label={t("registro.edad")}
                        rules={[
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                        ]}
                      >
                        <Select placeholder={t("registro.edadplaceholder")}>
                          <Option value="14">14</Option>
                          <Option value="15">15</Option>
                          <Option value="16">16</Option>
                          <Option value="17">17</Option>
                          <Option value="18">18</Option>
                          <Option value="19">19</Option>
                          <Option value="20">20</Option>
                          <Option value="21">21</Option>
                          <Option value="22">22</Option>
                          <Option value="23">23</Option>
                          <Option value="24">24</Option>
                          <Option value="25">{t("25omas")}</Option>
                        </Select>
                      </Form.Item>

                      <Form.Item
                        name="gender"
                        label={
                          <div>
                            <span>{t("registro.genero")}</span>&nbsp;&nbsp;
                          </div>
                        }
                        hasFeedback
                        rules={[{required: true, message: t("mandatory")}]}
                      >
                        <Select placeholder={t("registro.generop")}>
                          <Option value="f">{t("login.mujer")}</Option>
                          <Option value="m">{t("login.hombre")}</Option>
                          <Option value="n">{t("login.otro")}</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item className="buttons-pre-next">
                        <Button
                          className="primaryButton btnPrimaryWhite buttonSizeS"
                          onClick={() => setCurrent(current - 1)}
                          htmlType="button"
                        >
                          {t("atras")}
                        </Button>

                        <Button className="primaryButton btnPrimaryBlue buttonSizeS" type="primary" htmlType="submit">
                          {t("next")}
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              )}

              {current === 4 && (
                <div className="allHeightMobile is-scrollable is-scrollable--student">
                  <div className="textDesc margintop24">{t("registro.datosemail")}</div>
                  <div className="customTextSmall is-required">{t("obligatorio")}</div>
                  <div className="margintop24 allHeightMobile">
                    <Form
                      className="authForm allHeightMobile"
                      form={form}
                      onFinish={onFinishStep4}
                      name="basic"
                      layout="vertical"
                      labelCol={{span: 24}}
                      wrapperCol={{span: 24}}
                      initialValues={{remember: true}}
                      autoComplete="off"
                    >
                      {!vinculado && (
                        <Form.Item
                          name="age"
                          label={t("registro.edad")}
                          rules={[
                            {
                              required: true,
                              message: t("mandatory"),
                            },
                          ]}
                        >
                          <Select placeholder={t("registro.edadplaceholder")}>
                            <Option value="14">14</Option>
                            <Option value="15">15</Option>
                            <Option value="16">16</Option>
                            <Option value="17">17</Option>
                            <Option value="18">18</Option>
                            <Option value="19">19</Option>
                            <Option value="20">20</Option>
                            <Option value="21">21</Option>
                            <Option value="22">22</Option>
                            <Option value="23">23</Option>
                            <Option value="24">24</Option>
                            <Option value="25">{t("25omas")}</Option>
                          </Select>
                        </Form.Item>
                      )}

                      {!vinculado && (
                        <Form.Item
                          name="gender"
                          label={
                            <div>
                              <span>{t("registro.genero")}</span>&nbsp;&nbsp;
                            </div>
                          }
                          hasFeedback
                          rules={[{required: true, message: t("mandatory")}]}
                        >
                          <Select placeholder={t("registro.generop")}>
                            <Option value="f">{t("login.mujer")}</Option>
                            <Option value="m">{t("login.hombre")}</Option>
                            <Option value="n">{t("login.otro")}</Option>
                          </Select>
                        </Form.Item>
                      )}

                      {!vinculado && (
                        <Form.Item
                          label={t("registro.pais")}
                          name="country_id"
                          rules={[
                            {
                              required: true,
                              message: t("pais"),
                            },
                          ]}
                        >
                          <Select
                            value={valueCountry}
                            onChange={onChangeCountry}
                            placeholder={t("registro.courseplace")}
                            showSearch={true}
                            defaultActiveFirstOption={true}
                            filterOption={filterOption}
                            notFoundContent={null}
                          >
                            {countries.map((d) => {
                              return (
                                <Option value={d.id} key={d.id}>
                                  {d.name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      )}
                      {!vinculado && provinces && (
                        <Form.Item
                          label={t("registro.provincia")}
                          name="province_id"
                          rules={[
                            {
                              required: true,
                              message: t("mandatory"),
                            },
                          ]}
                        >
                          <Select
                            placeholder={t("registro.provincia")}
                            showSearch={true}
                            defaultActiveFirstOption={true}
                            filterOption={filterOption}
                            notFoundContent={null}
                          >
                            {provinces.map((d) => {
                              return (
                                <Option value={d.id} key={d.id}>
                                  {d.name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      )}
                      {!vinculado && (
                        <Form.Item
                          label={t("registro.curso")}
                          name="course_id"
                          rules={[
                            {
                              required: true,
                              message: t("mandatory"),
                            },
                          ]}
                        >
                          <Select
                            placeholder={t("registro.courseplace")}
                            showSearch={true}
                            defaultActiveFirstOption={true}
                            filterOption={filterOption}
                            notFoundContent={null}
                          >
                            {courses.map((d) => {
                              return (
                                <Option value={d.id} key={d.id}>
                                  {d.name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      )}

                      <Form.Item
                        name="email"
                        label={t("registro.email")}
                        rules={[
                          {
                            type: "email",
                            message: t("registro.emailIncorrect"),
                          },
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                        ]}
                      >
                        <Input placeholder={t("login.emailp")} />
                      </Form.Item>
                      <Form.Item
                        name="emailrep"
                        label={t("registro.cemail")}
                        rules={[
                          {
                            type: "email",
                            message: t("registro.emailIncorrect"),
                          },
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                          ({getFieldValue}) => ({
                            validator(_, value) {
                              if (!value || getFieldValue("email") === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error(t("registro.emailmis")));
                            },
                          }),
                        ]}
                      >
                        <Input placeholder={t("login.emailp")} />
                      </Form.Item>

                      <Form.Item
                        name="password"
                        label={
                          <div>
                            <span>{t("registro.password")}</span>&nbsp;&nbsp;
                            <Tooltip title={t("registro.tooltippassword")}>
                              <QuestionCircleOutlined />
                            </Tooltip>
                          </div>
                        }
                        rules={[
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                          {
                            validator: async () => {
                              return level >= minLevel ? Promise.resolve() : Promise.reject(errorMessage);
                            },
                            message: errorMessage,
                          },
                        ]}
                        hasFeedback
                      >
                        <PasswordInput
                          placeholder={t("registro.passwordp")}
                          onLevelChange={setLevel}
                          settings={{
                            height: 7,
                            alwaysVisible: true,
                            colorScheme: {
                              levels: ["#ff4033", "#fe940d", "#ffd908", "#cbe11d", "#6ecc3a"],
                              noLevel: "lightgrey",
                            },
                          }}
                        />
                      </Form.Item>

                      {/* <Form.Item
                            name="accept"
                            valuePropName="checked"
                            rules={[
                              {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                              },
                            ]}

                        >
                          <Checkbox>
                            {t("registro.acepto")}
                          </Checkbox>
                        </Form.Item> */}
                      <Form.Item
                        name="acceptconoce"
                        valuePropName="checked"
                        rules={[
                          {
                            validator: (_, value) =>
                              value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                          },
                        ]}
                      >
                        <Checkbox>
                          <div
                            className="customTextSmall"
                            dangerouslySetInnerHTML={{__html: t("registro.checkConoce")}}
                          />
                        </Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="acceptconfirma"
                        valuePropName="checked"
                        rules={[
                          {
                            validator: (_, value) =>
                              value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                          },
                        ]}
                      >
                        <Checkbox>
                          <div
                            className="customTextSmall"
                            dangerouslySetInnerHTML={{__html: t("registro.checkConfirma")}}
                          />
                        </Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="acceptconsiente"
                        valuePropName="checked"
                        rules={[
                          {
                            validator: (_, value) =>
                              value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                          },
                        ]}
                      >
                        <Checkbox>
                          {vinculado && (
                            <div
                              className="customTextSmall"
                              dangerouslySetInnerHTML={{__html: t("registro.checkConsiente")}}
                            />
                          )}
                          {!vinculado && (
                            <div
                              className="customTextSmall"
                              dangerouslySetInnerHTML={{__html: t("registro.checkConsienteInvitado")}}
                            />
                          )}
                        </Checkbox>
                      </Form.Item>

                      {!noCaptcha && <ReCAPTCHA ref={captchaRef} sitekey={process.env.REACT_APP_SITE_KEY} />}
                      {error && (
                        <Row>
                          <Col span={24}>
                            <Alert message={t(errorMsg)} type="error" />
                          </Col>
                        </Row>
                      )}
                      <Form.Item className="buttons-pre-next">
                        <Button
                          className="primaryButton btnPrimaryBlue buttonSizeS"
                          onClick={() => setCurrent(vinculado ? current - 1 : 0)}
                          htmlType="button"
                        >
                          {t("atras")}
                        </Button>
                        <Button
                          loading={loading}
                          className="primaryButton btnPrimaryWhite buttonSizeS"
                          type="primary"
                          htmlType="submit"
                        >
                          {t("next")}
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              )}
              {current === 6 && (
                <div className={"finishRegister"}>
                  <img className={"imgRegister center-text"} src={luxfi} height={240} />
                  <p className={"finish-text"}>{t("registro.finish")}</p>
                  {!vinculado ? (
                    <>
                      <p>{t("registro.finishsub")}</p>
                    </>
                  ) : (
                    <p>{t("registro.finishsub")}</p>
                  )}
                  <Button
                    onClick={() => {
                      if (auto) {
                        localStorage.removeItem(variables.LASTCEIBA);
                        localStorage.removeItem(variables.LASTTEK);
                        localStorage.removeItem(variables.LASTXCELENCE);
                        localStorage.removeItem(variables.LASTCERVO);
                        localStorage.removeItem(variables.LASTNOGAM3);
                        localStorage.removeItem(variables.LASTNOGAM4);
                        localStorage.removeItem(variables.LASTNOGAM5);
                        localStorage.removeItem(variables.LASTNOGAM6);
                      }
                      history.push(auto ? "/admin/dashboard" : "/auth/login")
                    }}
                    type={"primary"}
                    className="primaryButton buttonSizeO center-text"
                  >
                    {vinculado ? t("start") : t("start")}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(RegisterPage);
